var $b25678c505cad7eb$exports = {};
// @ts-ignore
function $b25678c505cad7eb$var$changeTab(evt, tabId) {
    let i, x, tabs;
    x = document.getElementsByClassName("display-content");
    for(i = 0; i < x.length; i++)x[i].style.display = "none";
    tabs = document.getElementsByClassName("tab-bar-item");
    for(i = 0; i < x.length; i++)tabs[i].className = tabs[i].className.replace(" tab-active", "");
    document.getElementById(tabId).style.display = "";
    evt.currentTarget.className += " tab-active";
}
window.changeTab = $b25678c505cad7eb$var$changeTab;


//# sourceMappingURL=repo.1d2d9dc2.js.map
